<script setup lang="ts">
/**
 * Root shell. Boots the theme + locale singletons (must run here so the stored
 * choice applies before any route renders labels) and the Android hardware
 * back-button handler, then hands off to the router. The survey flow lives at
 * `/` (SurveyShell.vue — splash + survey + my-surveys, extracted from the old
 * App.vue body); installer screens live under `/installer/*`.
 */
import { onMounted } from 'vue';
import { useTheme } from '@/composables/useTheme';
import { useLocale } from '@/composables/useLocale';
import { bootAndroidBackButton } from '@/composables/useAndroidBackButton';

// Boot the theme + locale singletons so they apply on first paint.
useTheme();
useLocale();

onMounted(() => {
  void bootAndroidBackButton();
});
</script>

<template>
  <RouterView />
</template>
